// extracted by mini-css-extract-plugin
module.exports = {"w1gpdsbs":"w1gpdsbs","spin-w1gpdsbs":"spin-w1gpdsbs"};